const consultaMedTurnosInitialState = {
    consultaMedTurnos: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default consultaMedTurnosInitialState;
  